import React from "react";
import s from "../Calendar.css";
import icon from "/public/SiteIcons/mage_filter.svg";
import messages from "../../../locale/messages";
import { injectIntl } from "react-intl"; // ✅ injectIntl

class CalendarDateHeader extends React.Component {
  render() {
    const { dates, showSearchText, onSearchChange, canScrollLeft, intl } =
      this.props;
    const { formatMessage } = intl;

    return (
      <div className={`${s.dFlex} ${s.minWidth3000}`}>
        <div className={`${s.search} ${canScrollLeft ? s.borderEnd : ""}`}>
          <div className={s.searchBox}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={formatMessage(messages.searchListings)}
              value={showSearchText}
              onChange={onSearchChange}
            />
            <img src={icon} className={s.searchIcon} alt="Search" />
          </div>
        </div>
        {dates.map((date) => (
          <div
            key={date.format("YYYY-MM-DD")}
            className={`text-center ${s.px2} ${s.py1} ${s.headCalendar}`}
          >
            <div className={s.day}>{date.format("ddd")}</div>
            <div className={s.date}>{date.format("DD MMM")}</div>
          </div>
        ))}
      </div>
    );
  }
}

export default injectIntl(CalendarDateHeader); // ✅ fixed
